import { z } from 'zod';
import { LEVELS, ROLES, CATEGORIES, define, DEFINITION_KINDS } from '../types.js';

/**
 * Require reference number for concierge pickup moves.
 */
export const schema = z.boolean();

export type ReferenceNumRequiredForPickup = z.infer<typeof schema>;

export const definition = define({
  key: 'reference_num_required_for_pickup',
  schema,
  label: 'Ref Required for Concierge Pickup',
  description: 'Require the reference number to be entered for concierge pickup moves.',
  kind: DEFINITION_KINDS.SETTING,
  category: CATEGORIES.REFERENCE_NUMBER.key,
  writableAtLevels: [LEVELS.HOPDRIVE, LEVELS.ORGANIZATION, LEVELS.CUSTOMER],
  readableByRoles: [ROLES.ADMIN],
  defaultValue: false,
});
